import { render, staticRenderFns } from "./CloseSvg.vue?vue&type=template&id=29c8d16f"
import script from "./CloseSvg.vue?vue&type=script&lang=js"
export * from "./CloseSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports